// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

const PointsTransfer = dynamic(() => import('./PointsTransfer').then(mod => mod.PointsTransfer));

export const PointsTransferConfig = {
  emptyLabel: 'PointsTransfer',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/pointstransfer`,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PointsTransferEditable = (props: any) => {
  return (
    <EditableComponent config={PointsTransferConfig} {...props}>
      <PointsTransfer {...props} />
    </EditableComponent>
  );
};
